import "./pactSafe"

const IsProduction = window.location.href.indexOf('app.bandwango.com') > -1;
const siteAccessId = IsProduction ? '9106fa0c-d2b4-4652-a9ad-08849116cedb' : '279c1928-6950-4686-9cdc-8afcd7589152';
import GroupsRepository from './Repositories/groups'

_ps('create', siteAccessId);
// _ps('create', siteAccessId, {dynamic:true});
_ps.on("error", function (message, event_type, context) {
    // Handle any errors.
    console.log(message);
});
const repositories = {
    groups: GroupsRepository(),
};

export default repositories
